import { ProfileCreateRequest, ProfileCreateUpdateResponse, ProfileLevelType, ProfileResponse, ProfilesClient, ProfileUpdateRequest } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const profileClient = new ProfilesClient(undefined, axios);

export const useProfiles = (options?: any) => {
  return useQuery<ProfileResponse[] | null>({
    ...options,
    queryKey: ["profiles"],
    initialData: null,
    queryFn: async () => profileClient.getProfiles(),
  });
};

export const useProfileDetails = (options?: any) => {
  return useQuery<ProfileResponse[] | null>({
    ...options,
    queryKey: ["profileDetails"],
    initialData: null,
    queryFn: async () => profileClient.getProfileDetails(),
  });
};

export const useProfileDetailsById = (profileId: string, options?: any) => {

  return useQuery<ProfileResponse | null>({
    ...options,
    queryKey: ["profileById", profileId],
    initialData: null,
    queryFn: async () => profileClient.getProfile(profileId),
  });
};

export const useProfileSearch = (profileLevelTypes: ProfileLevelType[], projectId: string | null | undefined, options?: any) => {
  return useQuery<ProfileResponse[] | null>({
    ...options,
    queryKey: ["profileSearch" + "_" + projectId, profileLevelTypes],
    initialData: null,
    queryFn: async () => profileClient.searchProfiles(profileLevelTypes, projectId),
  });
};

export const useUpdateProfile = (options?: any) => {
  return useMutation<ProfileCreateUpdateResponse>({
    ...options,
    mutationFn: (profileUpdateRequest: ProfileUpdateRequest) => {
      return profileClient.updateProfile(profileUpdateRequest.profileId!, profileUpdateRequest);
    },
    onSuccess: async (data: ProfileCreateUpdateResponse) => {
      if (!data.isDuplicate) {
        queryClient.setQueryData(["profiles", data.profileResponse?.profileId], data);
      }

      options?.onSuccess?.(data);
    },
  });
};

export const useCreateProfile = (options?: any) => {
  return useMutation<ProfileCreateUpdateResponse>({
    ...options,
    mutationFn: (profileRequest: ProfileCreateRequest) => profileClient.createProfile(profileRequest),
    onSuccess: async (data: ProfileCreateUpdateResponse) => {
      if (!data.isDuplicate) {
        queryClient.setQueryData(["profiles", data.profileResponse?.profileId], data);
      }

      options?.onSuccess?.(data);
    },
  });
};

export const useDeleteProfile = (options?: any) => {
  return useMutation({
    ...options,
    mutationFn: (profileId: string) => profileClient.deleteProfile(profileId)
  });
};
